// extracted by mini-css-extract-plugin
export default {"section":"Tr-z","inSectionButton":"Ur-z","addressCard":"Vr-z","disabled":"Wr-z","cautionBox":"Xr-z","failureBox":"Yr-z","fade-out":"Zr-z","successBox":"_r-z"};